import { ApiVersion } from './api-version';

export const ApiDocsUrls = {
  [ApiVersion.V1]: 'https://shipstation.com/docs/api',
  [ApiVersion.V2]: 'https://docs.shipstation.com/',
};

export const ApiContactSupportUrls = {
  [ApiVersion.V1]: 'mailto:apisupport@shipstation.com',
  [ApiVersion.V2]: 'mailto:shippingapisupport@shipstation.com',
};
